import './semantic.min.css'
import './App.css'
import 'whatwg-fetch' // Polyfill fetch
import React, { Component } from 'react'
import AppLoggedIn from './AppLoggedIn'
import { Loader } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import SignIn from './pages/SignIn'
import firebase from 'firebase'
import firebaseui from 'firebaseui'

class App extends Component {
	constructor() {
		super()
		this.authUi = new firebaseui.auth.AuthUI(firebase.auth())
	}
	render() {
		if (this.props.loading) {
			return <Loader active inline content="Loading" />
		}
		return (
			<div className="App">
				{this.props.user
					? <AppLoggedIn user={this.props.user} />
					: <div>
							<h2>Welcome to the exercise app</h2>
							<p>Sign in so we can track your progress</p>
							<SignIn authUi={this.authUi} />
						</div>}
			</div>
		)
	}
}
App.propTypes = {
	loading: PropTypes.bool.isRequired,
	recentExercise: PropTypes.object,
	recentLog: PropTypes.object,
	user: PropTypes.object
}

export default App



// WEBPACK FOOTER //
// ./src/App.js